import type { UploadRequestHandle, UploadRequestOptions } from './types'

/** Default transport performs an actual multipart request; selected local files are never marked uploaded. */
export function uploadRequest(options: UploadRequestOptions): UploadRequestHandle {
  const xhr = new XMLHttpRequest()
  xhr.open(options.method, options.action, true)
  xhr.withCredentials = options.withCredentials
  for (const [name, value] of Object.entries(options.headers)) xhr.setRequestHeader(name, value)
  const body = new FormData()
  for (const [name, value] of Object.entries(options.data)) body.append(name, value instanceof Blob ? value : String(value))
  body.append(options.filename, options.file, options.file instanceof File ? options.file.name : 'file')
  xhr.upload.onprogress = event => { if (event.lengthComputable) options.onProgress({ percent: event.loaded / event.total * 100 }) }
  xhr.onerror = () => options.onError(new Error(`上传请求失败：${options.action}`))
  xhr.onload = () => {
    let response: unknown = xhr.responseText
    if (xhr.getResponseHeader('content-type')?.includes('json') && xhr.responseText) {
      try { response = JSON.parse(xhr.responseText) }
      catch (error) { options.onError(error instanceof Error ? error : new Error(String(error))); return }
    }
    if (xhr.status >= 200 && xhr.status < 300) options.onSuccess(response, xhr)
    else options.onError(new Error(`上传失败：HTTP ${xhr.status}`), response)
  }
  xhr.send(body)
  return { abort: () => xhr.abort() }
}
